import React from 'react'
import { CommunityGrid,Heading,MainContainer,MarqueeImg,GridContainer,DividerImg } from './style'

const Community = () => {
  return (
    <MainContainer maxWidth="xxl">
        <GridContainer container>
            <CommunityGrid item xs={12}>
                    <DividerImg src="./assets/community-divider.png" />
                    <Heading data-aos="fade-right" data-aos-duration="2000">Building a Strong Community </Heading>
                    <marquee direction="right" data-aos="fade-right" data-aos-duration="2000">
                        <MarqueeImg src="./assets/ticker1.png" />
                        <MarqueeImg src="./assets/ticker1.png" />
                        <MarqueeImg src="./assets/ticker1.png" />
                        <MarqueeImg src="./assets/ticker1.png" />
                        <MarqueeImg src="./assets/ticker1.png" />
                        <MarqueeImg src="./assets/ticker1.png" />
                    </marquee>
                    <marquee direction="left" data-aos="fade-left" data-aos-duration="2000">
                        <MarqueeImg src="./assets/ticker1.png" />
                        <MarqueeImg src="./assets/ticker1.png" />
                        <MarqueeImg src="./assets/ticker1.png" />
                        <MarqueeImg src="./assets/ticker1.png" />
                        <MarqueeImg src="./assets/ticker1.png" />
                        <MarqueeImg src="./assets/ticker1.png" />
                    </marquee>
            </CommunityGrid>
        </GridContainer>
    </MainContainer>
  )
}

export default Community
